import styled from "styled-components";

const Container = styled.div`

`;

const GraphOperatorFieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .toggle-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;

        .MuiFormControlLabel-label {
            font-size: 14px;
        }
    }
`;

export {
    Container,
    GraphOperatorFieldWrapper
}